// you will need to add styling into your app.scss for the bold and italc styles

const markdownToHTML = (string) => {
    const output = string;
    const linkRegexp = /\[(.+?)\]\(((http|https):\/\/.+?)\)/g;
    const boldRegexp = /\*{2}(.+?)\*{2}/g;
    const italicRegexp = /_([^_]*)_/g;
    return output
        .replace(italicRegexp, '<span class="highlight--italic">$1</span>')
        .replace(boldRegexp, '<span class="highlight--bold">$1</span>')
        .replace(linkRegexp, '<a href="$2" target="_top">$1</a>');
};

module.exports = markdownToHTML;
